/* =============================================================================
   CONTROL V2 SPANISH - EXPI BENEFITS CAROUSEL JS
   JavaScript para el carousel de beneficios experienciales
   ============================================================================= */

document.addEventListener('DOMContentLoaded', () => {
    const expiCards = document.querySelectorAll('.expi-benefits-card');
    const expiPrevButton = document.querySelector('.expi-benefits-prev');
    const expiNextButton = document.querySelector('.expi-benefits-next');
    const expiProgressIndicator = document.querySelector('.expi-benefits-carousel-progress-indicator');
    const expiInnerTrack = document.querySelector('.expi-benefits-inner-track');

    // Exit if elements don't exist
    if (!expiCards.length || !expiPrevButton || !expiNextButton || !expiProgressIndicator || !expiInnerTrack) {
        return;
    }

    const expiTotalCards = expiCards.length;
    let expiCurrentIndex = 0;

    // Card width is 300px
    const expiCardWidth = 300;

    // Function to display the current card
    const showExpiCard = (index) => {
        let translateXValue = -(expiCardWidth * index);
        if (index === expiTotalCards - 1) {
            translateXValue += 45; // Adjust if necessary for the last card
        }
        expiInnerTrack.style.transform = `translateX(${translateXValue}px)`;
        updateExpiProgressBar(index);
    };

    // Function to update the progress bar
    const updateExpiProgressBar = (index) => {
        const progressPercentage = ((index + 1) / expiTotalCards) * 100;
        expiProgressIndicator.style.width = `${progressPercentage}%`;
    };

    // Event listener for the Previous button
    expiPrevButton.addEventListener('click', () => {
        expiCurrentIndex = (expiCurrentIndex === 0) ? expiTotalCards - 1 : expiCurrentIndex - 1;
        showExpiCard(expiCurrentIndex);
    });

    // Event listener for the Next button
    expiNextButton.addEventListener('click', () => {
        expiCurrentIndex = (expiCurrentIndex === expiTotalCards - 1) ? 0 : expiCurrentIndex + 1;
        showExpiCard(expiCurrentIndex);
    });

    // Swipe functionality variables
    let startX = 0;
    let isSwiping = false;

    // Event listener for touch start
    expiInnerTrack.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        isSwiping = true;
    });

    // Event listener for touch move (optional: can be used for visual feedback)
    expiInnerTrack.addEventListener('touchmove', (e) => {
        if (!isSwiping) return;
        // Optionally, implement visual feedback during swipe
    });

    // Event listener for touch end
    expiInnerTrack.addEventListener('touchend', (e) => {
        if (!isSwiping) return;
        isSwiping = false;

        const endX = e.changedTouches[0].clientX;
        const swipeThreshold = 50; // Minimum swipe distance in pixels

        if (startX - endX > swipeThreshold) {
            // Detected a swipe left
            expiCurrentIndex = (expiCurrentIndex === expiTotalCards - 1) ? 0 : expiCurrentIndex + 1;
            showExpiCard(expiCurrentIndex);
        } else if (endX - startX > swipeThreshold) {
            // Detected a swipe right
            expiCurrentIndex = (expiCurrentIndex === 0) ? expiTotalCards - 1 : expiCurrentIndex - 1;
            showExpiCard(expiCurrentIndex);
        }
    });

    // Initialize the carousel on page load
    showExpiCard(expiCurrentIndex);
});
